import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import {
  GET_FLAG_NOTI_FINE_REG,
  SET_ROUTE_LIST,
  SET_STD_KEY_FINE_REG_NOTI_READ,
} from "../../store/actionTypes";
import { useHistory } from "react-router-dom";
import {
  apiAuthDataScope,
  apiAuthLogin,
  apiAuthRouter,
  apiAuthSchedule,
  apiGetUserMenu,
  apiNewTokenByRole,
  apiSaveOAuthData,
} from "../../services/apis/AuthAndPermissionDataSource";
import { OAuthOpenIDDataSource } from "../../services/apis/OAuthOpenIDDataSource";
import { UserProfileDataSource } from "../../services/apis/UserProfileDataSource";
import { apiClient } from "../../services/api";
import { SwAlert } from "../commons/Sweetalert2Template/Sweetalert2Template";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ReactSwal = withReactContent(
  Swal.mixin({
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-warning btn-lg",
      cancelButton: "btn btn-default btn-lg",
      actions: "text-center",
    },
  })
);

const getScheduleParam = (loginData) => {
  let getScheduleParam = {};

  switch (loginData.user.userType) {
    case "1":
      getScheduleParam.stdStatusCode =
        loginData.user.student?.studentStatusCode;
      getScheduleParam.campusCode = loginData.user.student?.campusCode;
      getScheduleParam.facultyCode = loginData.user.student?.facultyCode;
      getScheduleParam.majorCode = loginData.user.student?.majorCode;
      getScheduleParam.edulevelCode = loginData.user.student?.edulevelCode;
      break;
    case "2":
      getScheduleParam.stdStatusCode = "";
      getScheduleParam.campusCode = loginData.user.teacher?.campusCode;
      break;
    case "3":
      getScheduleParam.stdStatusCode = "";
      getScheduleParam.campusCode = loginData.user.staff?.campusCode;
      break;
    case "4":
      getScheduleParam.stdStatusCode = "";
      getScheduleParam.campusCode = loginData.user.staff?.campusCode;
      break;

    default:
      break;
  }

  getScheduleParam.userType = loginData.user.userType;
  return getScheduleParam;
};

const createLoginDataObject = (loginData) => {
  return {
    getScheduleParam: getScheduleParam(loginData),
    loginData: loginData,
  };
};

export const getLogin = async (username, password) => {
  return await trackPromise(
    apiAuthLogin(username, password)
      .then(async (res) => {
        if (res.data.code === "success") {
          return createLoginDataObject(res.data);
        } else {
          //alert error
          let loginData = res.data;
          let message;
          if (loginData.code === "user_pw_incorrect") {
            message =
              "ไม่พบผู้ใช้งานบนระบบ my กรุณาตรวจสอบรหัสผู้ใช้งานหรือรหัสผ่านอีกครั้ง"; //'ไม่พบชื่อผู้ใช้งานบนระบบ my'
          } else if (loginData.code === "ldap_error") {
            message =
              "ไม่สามารถตรวจสอบผู้ใช้งานบน LDAP ได้ กรุณาติดต่อผู้ดูแลระบบ"; // 'รหัสผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง'
          } else if (
            loginData.code === "error" &&
            loginData.message === "get user profile error"
          ) {
            //! ERROR from KUISEA
            console.log("Error from KUISEA");
            message = "ไม่สามารถติดต่อกับระบบจัดการผู้ใช้งานได้";
          } else if (
            loginData.code === "error" &&
            loginData.message === "user profile not found"
          ) {
            message = "ไม่พบชื่อผู้ใช้งานบนระบบ my";
          } else if (
            loginData.code === "error" &&
            loginData.message === "Ldap authenticate error"
          ) {
            message = "ไม่สามารถเชื่อมต่อกับระบบจัดการผู้ใช้งานได้";
          } else if (loginData.message === "API rate limit exceeded") {
            message = "ไม่สามารถเข้าใช้งานได้ จำนวนผู้ใช้งานเกินกว่ากำหนด";
          } else {
            message =
              "ไม่สามารถเชื่อมต่อกับระบบจัดการผู้ใช้งานได้ กรุณาติดต่อผู้ดูแลระบบ";
          }

          SwAlert({
            icon: "warning",
            title: "ไม่สามารถเข้าสู่ระบบได้",
            description: message,
          });

          return false;
        }
      })
      .catch((e) => {
        console.log(e);
        SwAlert({
          icon: "warning",
          title: "ไม่สามารถเข้าสู่ระบบได้",
          description:
            "พบปัญหาในระหว่างการพยายามเข้าระบบ กรุณาติดต่อผู้ดูแลระบบ",
        });

        throw e;
      })
  );
};

export const getSchedule = async (scheduleParam) => {
  return await trackPromise(
    apiAuthSchedule(scheduleParam)
      .then((academicRes) => {
        console.log("YEAR is ", academicRes.data);
        console.log("academicRes", academicRes);
        if (academicRes.data && academicRes.data.code === "success") {
          return {
            academicYear: academicRes.data.results[0].academicYr,
            semester: academicRes.data.results[0].semester,
          };
        } else {
          throw new Error("calendar_error");
        }
      })
      .catch((e) => {
        throw new Error("calendar_error");
      })
  );
};

export const getRouter = async (roleId, menuSystem) => {
  return await trackPromise(
    apiAuthRouter(roleId, menuSystem)
      .then((response) => {
        console.log("here response", response);
        if (response.status === 404) {
          return [];
        }
        if (response.data && response.data.code === "success") {
          return response.data.results;
        }
      })
      .catch((e) => {
        throw new Error("router_error");
      })
  );
};

export const getRoleDataScope = async (roleId) => {
  return await trackPromise(
    apiAuthDataScope(roleId)
      .then((res) => {
        //todo : ปิดเงื่อนไขตอนที่ api มีค่ากลับมาแล้ว
        // if (res.data.status.code == 'success') {
        return res.data.data;
        // }
      })
      .catch((e) => {
        throw new Error("data_scope_error");
      })
  );
};

export const getNewTokenByRole = async (roleId) => {
  return await trackPromise(
    apiNewTokenByRole(roleId)
      .then((res) => {
        return res.data.data;
      })
      .catch((e) => {
        throw new Error("Failed to get new token by role.");
      })
  );
};

export const saveOauthLog = async (paramsObject) => {
  return await trackPromise(
    apiSaveOAuthData(paramsObject).catch((e) => {
      throw new Error("OAUTH_LOG_SAVE_FAILED");
    })
  );
};

export const getOauthToken = async (tokenParams) => {
  return await OAuthOpenIDDataSource.token(tokenParams)
    .then((response) => {
      if (!response.data || !response.data.access_token) {
        throw new Error("Failed to get oauth token.");
      }
      return response;
    })
    .catch((e) => {
      throw new Error("OAUTH_GET_FAILED");
    });
};

export const getUserKuByOauthToken = async (userInfoParams) => {
  return await OAuthOpenIDDataSource.userInfo(userInfoParams)
    .then((response) => {
      let userInfo = undefined;
      //todo : รอถามอุ้ยเรื่อง response
      if (response.data.uid) {
        userInfo = response.data;
      } else if (response.data.user) {
        userInfo = response.data.user;
      }

      if (!userInfo) {
        throw new Error("UserInfo not found.");
      }

      return userInfo;
    })
    .catch((e) => {
      throw new Error("Failed to get user info.");
    });
};

export const getLocalUserFromAllLoginUser = async (targetUser) => {
  return await UserProfileDataSource.userProfile(targetUser)
    .then((response) => {
      if (response.data && response.data.code === "success") {
        //todo : ต้องดูว่าของจริงกลับมาใน key ไหน
        return response.data;
      }
    })
    .catch((e) => {
      throw new Error("PROFILE_NOT_FOUND");
    });
};

export const getMobileUserProfileByAppAccessToken = async (targetUser) => {
  // For Mobile App Redirect to web and verify pass.
  return await UserProfileDataSource.mobileUserProfileByAppAccessToken(
    targetUser
  )
    .then((response) => {
      if (response.data && response.data.code === "success") {
        return response.data;
      }
    })
    .catch((e) => {
      console.error("failed to get user profile by app access token");
    });
};

export const getVerifyAccesstoken = async (params) => {
  // Verify App Access Token.
  return await UserProfileDataSource.verifyAccesstoken(params)
    .then((response) => {
      if (response.data && response.data.status.code == "200") {
        return response.data;
      }
      // else {
      //     console.error('ERROR_AUTHEN')
      //     SwAlert({
      //         icon: "error",
      //         title: "",
      //         description: "กรุณาลองใหม่อีกครั้ง",
      //         confirmButtonText: "ตกลง"
      //     })
      // }
    })
    .catch((e) => {
      throw new Error("Failed to verify token");
    });
};

const getRedirect = (user) => {
  console.log("login-web : creating redirect", user);
  let redirect;
  if (user) {
    const realRoleSystem = user.currentRoleSystem
      ? user.currentRoleSystem
      : user.role.roleSystem;
    const getRedirectPrefix = () => {
      if (realRoleSystem === "MY_KU" || realRoleSystem === "MY_KU") {
        return process.env.REACT_APP_MY_KU_PREFIX;
      }

      if (
        realRoleSystem === "MY_ADMIN" ||
        realRoleSystem === "MY_KU|MY_ADMIN"
      ) {
        return process.env.REACT_APP_MY_ADMIN_PREFIX;
      }
    };

    if (user.role && user.role.redirect) {
      redirect = `${user.role.redirect}`;
    } else {
      //plan B solution for user with no redirect
      console.log("user.currentRole", user.currentRole);
      switch (user.currentRole) {
        case 1: //  Role finance of campus B.
        case 7: //  Role finance of campus K.
        case 8: //  Role finance of campus S.
          redirect = "/fin/master/manageNormalFee";
          break;
        case 4: //  Role cur of staff.
          redirect = "/cur/master/subjectManagement";
          break;
        case 6: //  Role System admin.
          redirect = "/rap/master/roles";
          break;
        case 2: //  Role cur of faculty staff.
        case 3: //  Role cur of teacher.
        default: //  Another.
          redirect = "/landingpage";
      }

      // if (!redirect) {
      //     if (user.userType === '1') {
      //         redirect = '/std/announcement'
      //     } else if (user.userType === '2') {
      //         // redirect = '/reg/consider-course-changes'
      //         redirect = '/landingpage'
      //     } else if (user.userType === '4') {
      //         // redirect = '/teacher/consider-course-changes-assistant'
      //         redirect = '/landingpage'
      //     } else if (user.userType === '3') {
      //         redirect = '/fin/master/manageNormalFee'
      //     } else {
      //         redirect = '/eva/report/manageEvaluation/report'
      //     }
      // }
    }

    redirect = getRedirectPrefix() + redirect;
  }

  console.log("redirect target", redirect);
  return redirect;
};

export const renewtoken = async (token, tokenValidated = false) => {
  try {
    let response = await apiClient.post(
      process.env.REACT_APP_PHASE2_PATH_PREFIX + "/user-login/renew",
      {
        renewtoken: token,
      }
    );
    localStorage.setItem("accesstoken", response.data.accesstoken);
    if (!tokenValidated) {
      sessionStorage.removeItem("tokenValidated");
    }
    return response.data.accesstoken;
  } catch (error) {
    console.log("error renewing token", error);
    return false;
  }
};

export const createLocalRenewSession = (endAt) => {
  const offsetMinutes = 10;
  const endAtDateObject = new Date(endAt);
  console.log(
    "renew session end time",
    endAtDateObject,
    endAtDateObject.getTime()
  );
  let endAtlocal = new Date(endAt).setMinutes(
    endAtDateObject.getMinutes() - offsetMinutes
  );
  console.log("renew session end time(with offset)", endAtlocal);
  localStorage.setItem("renewtoken-timeout", endAtlocal);
  sessionStorage.removeItem("session-timeout-warning");
};

export const useAuth = () => {
  const dispatch = useDispatch();
  let history = useHistory();

  const baseUser = useSelector((state) => {
    return state.authen.user;
  });

  const permission = useSelector((state) => {
    return state.authen.user;
  });

  const currentUserRoles = useSelector((state) => {
    return state.authen.user?.roles;
  });

  const [isLoading, setIsLoading] = useState(true);

  const getRedirectFromRedirectPath = (user, redirectPath = "") => {
    console.log("login-web : creating redirect 2", user);
    let redirect = redirectPath;
    if (user) {
      const realRoleSystem = user.currentRoleSystem
        ? user.currentRoleSystem
        : user.role.roleSystem;
      const getRedirectPrefix = () => {
        if (realRoleSystem === "MY_KU" || realRoleSystem === "MY_KU") {
          return process.env.REACT_APP_MY_KU_PREFIX;
        }

        if (
          realRoleSystem === "MY_ADMIN" ||
          realRoleSystem === "MY_KU|MY_ADMIN"
        ) {
          return process.env.REACT_APP_MY_ADMIN_PREFIX;
        }
      };

      redirect = getRedirectPrefix() + redirect;
    }

    console.log("redirect target", redirect);
    return redirect;
  };

  const setLocalUser = async (loginResponse) => {
    console.log("setLocalUser with data", loginResponse);

    setIsLoading(true);

    let scheduleData = undefined;
    let routeList = undefined;
    let dataScope = undefined;
    let userMenus = undefined;
    // let redirect = getRedirect(loginResponse.loginData.user)

    try {
      console.log("setLocalUser setting up datas");
      createLocalRenewSession(loginResponse.loginData.renewExpiresin);

      //set storage (อาจจะไม่จำเป็นในอนาคต)
      localStorage.setItem("accesstoken", loginResponse.loginData.accesstoken);
      localStorage.setItem("renewtoken", loginResponse.loginData.renewtoken);

      console.log("auth loginResponse", loginResponse);

      scheduleData = await getSchedule(loginResponse.getScheduleParam);

      if (!scheduleData) {
        return false;
      }

      console.log("auth schedule data", scheduleData);

      loginResponse.loginData.user.academicYear = scheduleData.academicYear;
      loginResponse.loginData.user.semester = scheduleData.semester;

      routeList = await getRouter(
        loginResponse.loginData.user.role.roleId,
        loginResponse.loginData.user.role.roleSystem === "MY_ADMIN" ||
          loginResponse.loginData.user.role.roleSystem === "MY_KU|MY_ADMIN"
          ? "MY_ADMIN"
          : "MY_KU"
      );
      console.log("auth route list", routeList);

      if (!routeList) {
        return false;
      }

      console.log("auth route list pass");

      // loginResponse.loginData.user.routeList = routeList

      dataScope = await getRoleDataScope(
        loginResponse.loginData.user.role.roleId
      );
      if (!dataScope) {
        return false;
      }

      console.log("auth data scope", dataScope);

      userMenus = await getMenuLocal(
        loginResponse.loginData.user.role.roleId,
        loginResponse.loginData.user.roles
      );

      loginResponse.loginData.user.roleMenus = userMenus;

      console.log("user menus", userMenus);

      //บรรทัดนี้สำคัญ ถ้าไม่มีจะเจอ error
      loginResponse.loginData.user.permission = {};
      loginResponse.loginData.user.permission.dataScope = dataScope;

      loginResponse.loginData.user.currentRole =
        loginResponse.loginData.user.role.roleId;
      loginResponse.loginData.user.currentRoleSystem =
        loginResponse.loginData.user.role.roleSystem === "MY_ADMIN" ||
        loginResponse.loginData.user.role.roleSystem === "MY_KU|MY_ADMIN"
          ? "MY_ADMIN"
          : "MY_KU";

      const payload = {
        accesstoken: loginResponse.loginData.accesstoken,
        renewtoken: loginResponse.loginData.renewtoken,
        user: loginResponse.loginData.user,
        selectedSemester: scheduleData.semester,
        selectedAcademicYear: scheduleData.academicYear,
      };

      //========================  เริ่ม dispatch ==================================
      console.log("starting dispatch data to redux", payload);
      dispatch({
        type: "AUTH_LOGIN",
        payload: payload,
      });

      //todo : อาจจะไม่ต้องใช้แล้วเพราะ ตัว noti ไม่ได้อยู่ในระบบ my-admin
      dispatch({
        type: SET_STD_KEY_FINE_REG_NOTI_READ,
        payload: {
          user: loginResponse.loginData.user,
        },
      });
      dispatch({
        type: GET_FLAG_NOTI_FINE_REG,
        payload: {
          user: loginResponse.loginData.user,
        },
      });

      dispatch({
        type: SET_ROUTE_LIST,
        payload: routeList,
      });
    } catch (e) {
      localStorage.removeItem("accesstoken");
      localStorage.removeItem("renewtoken");
      localStorage.removeItem("renewtoken-timeout");
      throw e;
    } finally {
      setIsLoading(false);
    }

    // return redirect
  };

  const getMenuLocal = async (roleId, userRoles) => {
    let selectedRole = userRoles.find((item) => item.roleId === roleId);
    let params = {
      roleId: roleId,
      menu_system:
        selectedRole.roleSystem === "MY_ADMIN" ||
        selectedRole.roleSystem === "MY_KU|MY_ADMIN"
          ? "MY_ADMIN"
          : "MY_KU",
    };

    return await trackPromise(
      apiGetUserMenu(params)
        .then(async (res) => {
          if (res.data.code === "success") {
            console.log("getMenusByRoleId data", res.data);
            return res.data.results;
          } else {
            console.log("not success", res);
            return [];
          }
        })
        .catch((err) => {
          console.log(err);
          SwAlert({
            icon: "error",
            title:
              "ไม่สามารถดึงข้อมูลเมนูหน้าที่ในตอนนี้ได้ กรุณาติดต่อผู้ดูแล",
          });
          return [];
        })
    );
  };

  const login = async (
    username,
    password,
    intentUrl = null,
    remember = false
  ) => {
    setIsLoading(true);

    let loginData = undefined;

    try {
      loginData = await getLogin(username, password, remember);

      if (!(loginData && loginData.getScheduleParam)) {
        return false;
      }

      await setLocalUser(loginData);
      let redirectTarget = getRedirect(loginData.loginData.user);
      if (intentUrl) {
        console.log("redirect with intent url");
        redirectTarget = intentUrl;
      }

      //================================ redirect =========================
      console.log("trying to redirect 1", redirectTarget);
      //todo : ควรจะเปลี่ยนเพราะตอนนี้มัน push อะไรก็ไปที่ redirect แน่นอน
      //เปลี่ยนเป็น refresh อาจจะไม่ได้
      history.push({
        pathname: redirectTarget,
      });
    } catch (e) {
      if (!e.message) {
        e.message = "กรุณาลองใหม่อีกครั้ง<br/>(Please try again.)";
      }
      switch (e.message) {
        case "calendar_error":
          e.message =
            "ไม่พบข้อมูลปฏิทินการศึกษา<br/>กรุณาติดต่อผู้ดูแลระบบ<br/>(The education calendar could not be found.<br/>Please contact your administrator.)";
          break;
        default:
          e.message = "กรุณาลองใหม่อีกครั้ง<br/>(Please try again.)";
      }
      ReactSwal.fire({
        title: "ไม่สามารถเข้าสู่ระบบได้",
        html: typeof e === "string" ? e : e.message,
      }).then(async () => {
        window.location.href = "/";
      });
    } finally {
      setIsLoading(false);
    }
  };

  const loginByOauth = async (code, sessionState, search) => {
    setIsLoading(true);

    let tokenRes = undefined;
    let allLoginUserInfo = undefined;
    let localUser = undefined;

    try {
      //localStorage.setItem("id_token", code) // Keep for logout session.

      //สำหรับไว้อ้างอิงการ login oauth
      const code_verifier = localStorage.getItem("code_verifier");
      localStorage.removeItem("code_verifier");

      const tokenParams = {
        code_verifier: code_verifier,
        code: code,
      };

      //เส้นที่ยิงไปไม่ใช่ ระบบภายใน
      tokenRes = await getOauthToken(tokenParams);

      localStorage.setItem("id_token", tokenRes.data.id_token); // Keep for logout session.
      const userToken = {
        access_token: tokenRes.data.access_token,
      };

      //เส้นที่ยิงไปไม่ใช่ ระบบภายใน
      // allLoginUserInfo = await getUserKuByOauthToken(userToken);

      //todo : ลบออก เพราะชุดนี้ใช้สำหรับ mockup เท่านั้น สำหรับสร้าง user ปลอมในกรณีที่ login ด้วย oauth
      const targetUser = {
        // uid: allLoginUserInfo.uid, //createFakeUid(allLoginUserInfo)
        access_token: tokenRes.data.access_token,
      };

      console.log("target user", targetUser);

      //เส้นนี้เป็นระบบภายใน
      localUser = await getLocalUserFromAllLoginUser(targetUser);

      const loginData = createLoginDataObject(localUser);

      await setLocalUser(loginData);
      let redirectTarget = getRedirect(loginData.loginData.user);
      const saveLog = {
        code: code,
        session_state: sessionState,
        authorize_raw_data: search,
      };

      await saveOauthLog(saveLog);

      //================================ redirect =========================
      console.log("trying to redirect 2");
      //todo : ควรจะเปลี่ยนเพราะตอนนี้มัน push อะไรก็ไปที่ redirect แน่นอน
      //เปลี่ยนเป็น refresh น่าจะได้
      history.push({
        pathname: redirectTarget,
      });
    } catch (e) {
      //unconfirmed : ถ้า fail อาจจะต้องไปยิง logout
      localStorage.removeItem("id_token");
      throw e;
    } finally {
      setIsLoading(false);
    }
  };

  const loginByTrustParams = async ({
    //  Support Mobile App Redirect.
    accesstoken, //  x-accesstoken.
    redirectPath, //  Path for redirect.
    oauthtoken, //  from mobile.
    route_code, //  from mobile. redirect to some page w/ code condition
  }) => {
    setIsLoading(true);

    let localUser = undefined;

    try {
      //เส้นที่ยิงไปเพื่อตรวจสอบ Parameter
      //trustUserFromInfo = await verifyTrustParams(clientSecret, uid, accesstoken)

      //todo : ลบออก เพราะชุดนี้ใช้สำหรับ mockup เท่านั้น สำหรับสร้าง user ปลอมในกรณีที่ login ด้วย oauth
      const targetUser = {
        //uid: uid,
        access_token: accesstoken,
      };

      console.log("target user", targetUser);

      //เส้นนี้เป็นระบบภายใน
      //localUser = await getLocalUserFromAllLoginUser(targetUser);
      localUser = await getMobileUserProfileByAppAccessToken(targetUser);

      const loginData = createLoginDataObject(localUser);

      await setLocalUser(loginData);
      let redirectTarget = getRedirectFromRedirectPath(
        loginData.loginData.user,
        redirectPath
      );

      // const saveLog = {
      //     code: code,
      //     session_state: sessionState,
      //     authorize_raw_data: search,
      // }
      // await saveOauthLog(saveLog)

      //================================ redirect =========================
      console.log(
        "trying to redirect 3",
        window.location.origin + redirectTarget
      );

      if (route_code == "MY_REG_77") {
        localStorage.setItem(
          "openAdjStdInfo",
          JSON.stringify({ mode: "CREATE", module_code: "MOBILE" })
        );
      }

      window.location.replace(window.location.origin + redirectTarget);
    } catch (e) {
      throw e;
    } finally {
      setIsLoading(false);
    }
  };

  const logoutLocal = async () => {
    console.log("trying to logout local");
    await trackPromise(
      apiClient
        .post("/user-login/logout")
        .then((res) => {
          console.log("response from /user-login/logout ");
          console.log(res);
          if (res) {
            // console.log(res.data);
            const data = res.data;
            console.log("logout", data);
            // debugger
            if (data.code === "success") {
              console.log("success");
              dispatch({ type: "AUTH_LOGOUT" });
            } else {
              console.log("Not success!");
              dispatch({ type: "AUTH_LOGOUT" });
            }
          } else {
            dispatch({ type: "AUTH_LOGOUT" });
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: "AUTH_LOGOUT" });
        })
        .finally(() => {
          window.location.href = process.env.REACT_APP_LOGIN_ROUTE;
        })
    );
  };

  const logoutOauth = () => {
    const id_token = localStorage.getItem("id_token");
    if (id_token) {
      console.log("loged in by oauth");
      const logoutUrl =
        process.env.REACT_APP_OAUTH_URL +
        process.env.REACT_APP_OAUTH_PATH_LOGOUT;
      const post_logout_redirect_uri =
        process.env.REACT_APP_OAUTH_BASE_URL +
        process.env.REACT_APP_OAUTH_URL_LOGOUT_CALLBACK;
      localStorage.removeItem("id_token");
      console.log(
        "LOG >>>>>>> ",
        `${logoutUrl}?post_logout_redirect_uri=${post_logout_redirect_uri}&id_token_hint=${id_token}`
      );
      window.location.href = `${logoutUrl}?post_logout_redirect_uri=${post_logout_redirect_uri}&id_token_hint=${id_token}`;
    } else {
      console.log("not loged in by oauth");
    }
  };

  const logout = async () => {
    console.log("logging out...");
    sessionStorage.removeItem("tokenValidated");
    localStorage.removeItem("renewtoken-timeout");
    localStorage.removeItem("accesstoken");
    localStorage.removeItem("renewtoken");
    localStorage.removeItem("user");
    localStorage.removeItem("userinfo");

    await logoutLocal();
    logoutOauth();
  };

  const changeRole = async (roleId) => {
    let selectedRole = currentUserRoles.find((item) => item.roleId === roleId);

    if (baseUser.currentRole === roleId) {
      console.log("no role change");
      return;
    }

    if (!selectedRole) {
      console.log("no selected roles --> logout");
      logout();
    }

    let params = {
      roleId: roleId,
      menu_system:
        selectedRole.roleSystem === "MY_ADMIN" ||
        selectedRole.roleSystem === "MY_KU|MY_ADMIN"
          ? "MY_ADMIN"
          : "MY_KU",
    };

    await trackPromise(
      apiGetUserMenu(params)
        .then(async (res) => {
          if (res.data.code === "success") {
            console.log("getMenusByRoleId data", res.data);
            let roleMenus = res.data.results;

            //load new routing
            const routeList = await getRouter(
              roleId,
              selectedRole.roleSystem === "MY_ADMIN" ||
                selectedRole.roleSystem === "MY_KU|MY_ADMIN"
                ? "MY_ADMIN"
                : "MY_KU"
            );

            if (!routeList) {
              throw "no route";
            }

            //load data scope
            const dataScope = await getRoleDataScope(roleId);

            if (!dataScope) {
              throw "no data scope";
            }

            const newToken = await getNewTokenByRole(roleId);

            baseUser.roleMenus = roleMenus;
            // baseUser.routeList = routeList
            baseUser.permission = {};
            baseUser.permission.dataScope = dataScope;
            baseUser.currentRole = roleId;
            baseUser.currentRoleSystem =
              selectedRole.roleSystem === "MY_ADMIN" ||
              selectedRole.roleSystem === "MY_KU|MY_ADMIN"
                ? "MY_ADMIN"
                : "MY_KU";

            console.log("base user", baseUser);

            //set data
            const payload = {
              accesstoken: newToken.accesstoken,
              renewtoken: newToken.renewtoken,
              user: baseUser,
              selectedSemester: baseUser.semester,
              selectedAcademicYear: baseUser.academicYear,
            };

            createLocalRenewSession(newToken.renewExpiresin);

            //set storage (อาจจะไม่จำเป็นในอนาคต)
            localStorage.setItem("accesstoken", newToken.accesstoken);
            localStorage.setItem("renewtoken", newToken.renewtokenn);

            //========================  เริ่ม dispatch ==================================
            dispatch({
              type: "AUTH_LOGIN",
              payload: payload,
            });

            dispatch({
              type: SET_ROUTE_LIST,
              payload: routeList,
            });

            //todo : change to landing page
            const redirectTarget = getRedirect(baseUser);

            //================================ redirect =========================
            console.log(
              "trying to redirect 4",
              window.location.origin + redirectTarget
            );
            window.location.replace(window.location.origin + redirectTarget);
          } else {
            console.log("not success", res);
          }
        })
        .catch((err) => {
          console.log(err);
          SwAlert({
            icon: "error",
            title: "ไม่สามาระเปลี่ยนแปลงหน้าที่ในตอนนี้ได้ กรุณาติดต่อผู้ดูแล",
          });
        })
    );
  };

  return {
    login: login,
    loginByOauth: loginByOauth,
    setPermissionLoading: setIsLoading,
    isPermissionLoading: isLoading,
    logoutLocal: logoutLocal,
    logoutOauth: logoutOauth,
    logout: logout,
    changeRole: changeRole,
    getRedirect: getRedirect,
    loginByTrustParams,
  };
};
